import React, { useState } from "react"
import AccountEditForm from "../components/AccountEditForm"
import Header from "../components/Header"
import { useId } from "./useId"

function AccountEdit(props) {
    let { id } = useId(props)

    const [title, setTitle] = useState("Edit Account")

    return (
        <Header title={title}>
            <AccountEditForm id={id} setTitle={setTitle} />
        </Header>
    )
}

export default AccountEdit
